import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { buscarFluido, incluirFluido, alterarFluido, excluirFluido } from '../../services/apigateway';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';
import ModalSenha from '../../components/Modal/modalsenha';

export default function CadastroFluidos({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);

  //const { defineCodigo } = useContext(AuthContext);
  const { codigo } = useParams();
  const history = useNavigate();

  const readOnly = (funcao === 'Consulta' || funcao === 'Exclusão');

  const[nome, setNome] = useState('');
  const[situacao, setSituacao] = useState('A');
  const[loading, setLoading] = useState(false);

  const [mostrarModal, setMostrarModal] = useState(false);

  useEffect(()=>{
    async function loadFluido(){
      setLoading(true);

      try {
        const response = await buscarFluido(clienteId, codigo);
        preencheSelecionado(response);

      } catch (err) {
        // console.log(`Retornou o seguinte erro: ${err}`);
        setLoading(false);
        toast.error('Erro ao buscar fluido');
      }
  
      setLoading(false);
    }

    if (funcao !== 'Inclusão' && funcao !== 'Consulta' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModal(true);
      return;
    }

    if (funcao !== 'Inclusão'){
      loadFluido();
    }
  }, []);


  function preencheSelecionado(response) {
    setNome(response[0].nom_fluido);
    setSituacao(response[0].sit_fluido);
  }

  function autorizado() {
    // console.log("Autorizado");
    setMostrarModal(false);
  }

  function naoAutorizado() {
    setMostrarModal(false);
    history('/desvios');
  }

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Consulta') {
      history('/fluidos');
    }

    if (funcao === 'Alteração' || funcao === 'Inclusão') {
      if (nome === '' || situacao === '') {
        toast.error('Informe todos os campos obrigatórios');
        return;
      }
    }

    if (funcao === 'Alteração') {
      //UPDATE
      try {
        const response = await alterarFluido(clienteId, { codigo: codigo, nome: nome, situacao: situacao });

        if (response === 200) {
          toast.success('Fluido alterado com sucesso!!');
          history('/fluidos');

        } else {
            toast.error('Erro na alteração do fluido (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na alteração do fluido - Retorno');
      }
    }

    if (funcao === 'Inclusão') {
      //INSERT
      try {
        const response = await incluirFluido(clienteId, { nome: nome, situacao: situacao });

        if (response === 200) {
          toast.success('Fluido incluído com sucesso!!');
          history('/fluidos');

        } else {
            toast.error('Erro na inclusão do fluido (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na inclusão do fluido - Retorno');
      }
    }

    if (funcao === 'Exclusão') {
      // //DELETE
      try {
        const response = await excluirFluido(clienteId, codigo);

        if (response === 200) {
          toast.success('Fluido excluído com sucesso!!');
          history('/fluidos');

        } else {
            toast.error('Erro na exclusão do fluido (sql) ' + response);
        }

      } catch(err) {
        console.log(err);
        toast.error('Erro na exclusão do fluido - Retorno');
      }
    }

    return;
  }

  function handleSair(e){
   history('/fluidos');
}

  if (mostrarModal) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Fluido'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Fluido...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Fluidos ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>
            <form method='POST' id='form-geral' className='form-geral'>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Informações do Fluido</h3>
              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Nome</label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='nome' 
                      name='nome' 
                      placeholder={'Digite o nome do fluido'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='nome' 
                      value={nome} 
                      onChange={(e) => setNome(e.target.value)}
                      required 
                      readOnly={(funcao === 'Consulta' || funcao === 'Exclusão')}
                    />
                      
                  </div>
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'>Situação</h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ativo' 
                        name='ativar' 
                        value='A' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'A'}
                        disabled={readOnly}
                      /> 
                      <label className='mb-0'>Ativo</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='inativo' 
                        name='ativar' 
                        value='I' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'I'}
                        disabled={readOnly}
                      /> 
                      <label>Inativo</label>
                    </div>
                  </div>
                </div>
              </div>

              <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
            </form>
          </section>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
